import clsx from 'clsx';
import React, { useState, useRef, useEffect } from 'react';
import styles from './StickySearchWrapper.module.scss';

interface StickySearchWrapperProps {
  children: any;
  target?: string;
  className?: string;
}

export default function StickySearchWrapper({
  children,
  target = 'scrollable-view',
  className
}: StickySearchWrapperProps) {
  const [fixedPosition, setFixedPosition] = useState(false);
  const wrapperRef = useRef(null);

  /**
   * get the top position of search wrapper and the top of the scrolled position
   * if the offset reached 20px, set the position of search wrapper to fixed
   * threshold kept as 20px as search wrapper has a top padding of 20px to maintain the consistent spacing from top even on scroll
   */
  const handleScroll = event => {
    const offset =
      wrapperRef.current.getBoundingClientRect().top - event.target.getBoundingClientRect().top;
    if (offset <= 20) {
      setFixedPosition(true);
    } else {
      setFixedPosition(false);
    }
  };

  useEffect(() => {
    document.getElementById(target).addEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={clsx(styles.searchHolder, className, fixedPosition && styles.fixedPosition)}
    >
      <div className={styles.gradientBackdrop} />
      {children}
    </div>
  );
}
